import { API } from '@/constants/api';
import http from '@/http';
import { alertError } from '@/utils/notification';
import { camelize, snakelize } from '@/utils/parse';

export async function updateIPs({ whitelistIps }) {
  try {
    const payload = snakelize({ whitelistIps });
    const { status } = await http.post(API.AUTHENTICATE.LIST_IPS, payload);
    if (status === 200) {
      return {
        success: true,
      };
    }
    return {
      success: false,
    };
  } catch (error) {
    if (error.response) {
      const { errorCode } = camelize(error.response.data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
    };
  }
}

export async function generateAPIKey() {
  try {
    const { status, data } = await http.post(API.AUTHENTICATE.GENERATE_KEY, {});
    if (status === 200) {
      return {
        success: true,
        data: camelize(data),
      };
    }
    return {
      success: false,
    };
  } catch (error) {
    if (error.response) {
      const { errorCode } = camelize(error.response.data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
    };
  }
}

export async function getIPs() {
  try {
    const { status, data } = await http.get(API.AUTHENTICATE.LIST_IPS);
    if (status === 200) {
      return {
        success: true,
        data: camelize(data),
      };
    }
    return {
      success: false,
      data: null,
    };
  } catch (error) {
    if (error.response) {
      const { errorCode } = camelize(error.response.data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
      data: null,
    };
  }
}
